<h2 mat-dialog-title>{{ data.title || 'Please confirm' }}</h2>

<mat-dialog-content>
  <p>{{ data.message }}</p>

  <!-- bankRemoval variant -->
  <ng-container *ngIf="data.confirmType === 'bankRemoval'; else genericInfo">
    <p class="bank-summary">
      <br>
      <strong>{{ data.nickname }}</strong> {{ data.last4 }}
    </p>
  </ng-container>

  <!-- generic Type/ID info -->
  <ng-template #genericInfo>
    <p><strong>Type:</strong> {{ data.typeLabel }}</p>
    <p><strong>ID:</strong> {{ data.idLabel }}</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">
    {{ data.cancelText || 'No' }}
  </button>
  <button mat-flat-button color="warn" (click)="onConfirm()">
    {{ data.confirmText || 'Yes' }}
  </button>
</mat-dialog-actions>
